import { createAsyncThunk } from '@reduxjs/toolkit';
import { Action, WidgetSessionState } from '@wix/wix-help-widget-common/types';
import { createPath } from 'react-router-dom';

import { WidgetRuntimeState } from '../../../types/appState';
import { appRoutes } from '../../routes';
import { getRouterBaseName, trimBaseName } from '../../routes/utils';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { updateWidgetSession } from '../api/updateWidgetSession';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();

const getFirstUrl = () => {
  const routerBaseName = getRouterBaseName(window.location.pathname);
  return trimBaseName(routerBaseName, createPath(window.location)) || appRoutes.home();
};

const updateFirstNavigationIfNeeded = async (widgetSession?: WidgetSessionState) => {
  if (widgetSession && widgetSession.navigationHistory && !widgetSession.navigationHistory.length) {
    await updateWidgetSession({
      tabId: widgetSession.sessionTabId,
      action: Action.Push,
      url: getFirstUrl(),
    });
  }
};

export const getWidgetRuntimeState = createAsyncThunk<WidgetRuntimeState, HttpClientFactory>(
  'getWidgetRuntimeState',
  async (httpClient: HttpClientFactory) => {
    if (renderModel.provideRuntimeDataFromSDK()) {
      const widgetRuntimeState = await widgetSDK.getRuntimeState();
      await updateFirstNavigationIfNeeded(widgetRuntimeState.widgetSession);
      return widgetRuntimeState;
    }

    // since we have ContactApp for Wix Native App it should not be reachable.
    // WidgetApp always runs with a widget script(help-center-client package) and provideRuntimeDataFromSDK should always be 'true'

    // add logger to debug why we have this scenario(`renderModel.provideRuntimeDataFromSDK()` should always be true)
    logger.info('Unexpected provideRuntimeDataFromSDK value for widget', renderModel.get());

    fedopsLogger.interactionStarted('fetching-widget-runtime-state');
    const { data } = await httpClient.getInstance().post(clientTopology.widgetRuntimeUrl);
    fedopsLogger.interactionEnded('fetching-widget-runtime-state');
    return data;
  },
);
